import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { isSupabaseConfigured, supabase } from './lib/supabase'

const PROVIDERS = [
  { id: 'meta', name: 'Meta', detail: 'Meta Ads, Instagram y Facebook', icon: 'M' },
  { id: 'google', name: 'Google', detail: 'Google Analytics 4 y Google Ads', icon: 'G' },
  { id: 'shopify', name: 'Shopify', detail: 'Ventas, pedidos, productos y clientes', icon: 'S' },
  { id: 'tiktok', name: 'TikTok', detail: 'TikTok Ads', icon: 'T' },
]

const TEAM_NAV = [
  ['agency', 'Resumen'],
  ['clients', 'Clientes'],
  ['connections', 'Conexiones y métricas'],
  ['builder', 'Dashboard y métricas'],
  ['goals', 'Objetivos'],
  ['tasks', 'Actividades'],
  ['meetings', 'Reuniones'],
  ['reports', 'Reportes'],
  ['admin', 'Administración'],
]

const CLIENT_NAV = [
  ['summary', 'Resumen'],
  ['dashboard', 'Dashboard'],
  ['goals', 'Objetivos'],
  ['tasks', 'Actividades'],
  ['meetings', 'Reuniones'],
  ['reports', 'Reportes'],
  ['admin', 'Administración'],
]

function Icon({ name, size = 20 }) {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }

  const paths = {
    agency: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </>
    ),
    summary: (
      <>
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </>
    ),
    clients: (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </>
    ),
    connections: (
      <>
        <path d="M10 13a5 5 0 0 0 7.07.07l2-2a5 5 0 0 0-7.07-7.07l-1.15 1.15" />
        <path d="M14 11a5 5 0 0 0-7.07-.07l-2 2A5 5 0 0 0 12 20l1.15-1.15" />
      </>
    ),
    builder: (
      <>
        <path d="M4 20V10" />
        <path d="M10 20V4" />
        <path d="M16 20v-7" />
        <path d="M22 20V7" />
      </>
    ),
    dashboard: (
      <>
        <path d="M4 20V10" />
        <path d="M10 20V4" />
        <path d="M16 20v-7" />
        <path d="M22 20V7" />
      </>
    ),
    goals: (
      <>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="5" />
        <circle cx="12" cy="12" r="1" />
      </>
    ),
    tasks: (
      <>
        <rect x="3" y="4" width="18" height="17" rx="2" />
        <path d="M8 2v4M16 2v4M3 9h18" />
        <path d="m8 14 2 2 4-4" />
      </>
    ),
    meetings: (
      <>
        <path d="M4 4h16v12H4z" />
        <path d="M8 20h8M12 16v4" />
      </>
    ),
    reports: (
      <>
        <path d="M4 19V5a2 2 0 0 1 2-2h9l5 5v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2Z" />
        <path d="M14 3v6h6M8 13h8M8 17h6" />
      </>
    ),
    admin: (
      <>
        <path d="M4 21h16" />
        <path d="M6 21V10h12v11" />
        <path d="M8 10V5h8v5" />
        <path d="M9 14h2M13 14h2M9 18h2M13 18h2" />
      </>
    ),
    search: (
      <>
        <circle cx="11" cy="11" r="7" />
        <path d="m20 20-3.5-3.5" />
      </>
    ),
    bell: (
      <>
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
        <path d="M10 21h4" />
      </>
    ),
    eye: (
      <>
        <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
        <circle cx="12" cy="12" r="2.5" />
      </>
    ),
    eyeOff: (
      <>
        <path d="m3 3 18 18" />
        <path d="M10.6 10.7a2 2 0 0 0 2.7 2.7" />
        <path d="M9.9 4.2A10.8 10.8 0 0 1 12 4c6.5 0 10 8 10 8a17.6 17.6 0 0 1-2.1 3.2" />
        <path d="M6.6 6.6C3.5 8.5 2 12 2 12s3.5 8 10 8a10.5 10.5 0 0 0 5.4-1.5" />
      </>
    ),
    logout: (
      <>
        <path d="M10 17l5-5-5-5" />
        <path d="M15 12H3" />
        <path d="M14 3h5a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5" />
      </>
    ),
    plus: (
      <>
        <path d="M12 5v14M5 12h14" />
      </>
    ),
    chevron: (
      <>
        <path d="m9 18 6-6-6-6" />
      </>
    ),
    trend: (
      <>
        <path d="m3 17 6-6 4 4 8-8" />
        <path d="M15 7h6v6" />
      </>
    ),
    dollar: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8M12 6v12" />
      </>
    ),
    users: (
      <>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      </>
    ),
    wallet: (
      <>
        <path d="M4 5h14a2 2 0 0 1 2 2v12H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z" />
        <path d="M16 10h6v5h-6a2.5 2.5 0 0 1 0-5Z" />
      </>
    ),
    calendar: (
      <>
        <rect x="3" y="4" width="18" height="17" rx="2" />
        <path d="M8 2v4M16 2v4M3 9h18" />
      </>
    ),
  }

  return <svg {...common}>{paths[name] || paths.agency}</svg>
}

const money = (value, currency = 'COP') =>
  new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(Number(value || 0))

const number = value =>
  new Intl.NumberFormat('es-CO', {
    maximumFractionDigits: 2,
  }).format(Number(value || 0))

const formatValue = (value, unit, currency = 'COP') =>
  unit === 'currency'
    ? money(value, currency)
    : unit === 'percent'
      ? `${number(value)}%`
      : number(value)

const dateText = value =>
  value
    ? new Intl.DateTimeFormat('es-CO', {
        dateStyle: 'medium',
      }).format(new Date(value))
    : 'Sin fecha'

function Login({ onReady }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setMessage('')

    const { error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })

    setBusy(false)

    if (error) {
      setMessage(error.message)
    } else {
      onReady?.()
    }
  }

  async function recover() {
    if (!email) {
      setMessage('Escribe primero tu correo.')
      return
    }

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: window.location.origin,
    })

    setMessage(
      error
        ? error.message
        : 'Te enviamos el enlace de recuperación.',
    )
  }

  return (
    <div className="login-shell">
      <section className="login-brand">
        <img
          src="/assets/logo-blanco.png"
          className="login-logo"
          alt="InsightLab"
        />

        <div className="eyebrow light">
          INSIGHTLABOS HUB CLIENTOPS
        </div>

        <h1>
          Tu cuenta, tus resultados y el seguimiento de tu operación.
        </h1>

        <p>
          Un espacio privado para el equipo de InsightLab y para cada
          cliente, con datos, objetivos, actividades, reuniones,
          reportes y documentos.
        </p>

        <div className="login-points">
          <span>Datos conectados</span>
          <span>Accesos por rol</span>
          <span>Seguimiento por cliente</span>
        </div>
      </section>

      <section className="login-panel">
        <form className="login-card" onSubmit={submit}>
          <img
            src="/assets/logo-azul.png"
            className="login-logo-blue"
            alt="InsightLab"
          />

          <h2>Ingresar a ClientOps</h2>

          <p>Utiliza el usuario asignado por InsightLab.</p>

          <label>
            Correo electrónico

            <input
              type="email"
              value={email}
              onChange={event => setEmail(event.target.value)}
              required
            />
          </label>

          <label>
            Contraseña

            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={event => setPassword(event.target.value)}
                required
              />

              <button
                type="button"
                className="password-toggle"
                onClick={() =>
                  setShowPassword(value => !value)
                }
                aria-label={
                  showPassword
                    ? 'Ocultar contraseña'
                    : 'Mostrar contraseña'
                }
                title={
                  showPassword
                    ? 'Ocultar contraseña'
                    : 'Mostrar contraseña'
                }
              >
                <Icon
                  name={showPassword ? 'eyeOff' : 'eye'}
                  size={20}
                />
              </button>
            </div>
          </label>

          {message && (
            <div className="notice">
              {message}
            </div>
          )}

          <button
            className="btn primary wide"
            disabled={busy}
          >
            {busy ? 'Ingresando…' : 'Ingresar'}
          </button>

          <button
            type="button"
            className="link-btn"
            onClick={recover}
          >
            Recuperar contraseña
          </button>

          <small>
            Acceso privado. Cada usuario ve únicamente la información
            autorizada.
          </small>
        </form>
      </section>
    </div>
  )
}

function SetupRequired() {
  return (
    <div className="setup-screen">
      <div className="setup-card">
        <img
          src="/assets/logo-azul.png"
          alt="InsightLab"
        />

        <h1>Falta conectar Supabase</h1>

        <p>
          Este proyecto ya está listo para GitHub y Cloudflare Pages.
          Crea las variables <code>VITE_SUPABASE_URL</code> y{' '}
          <code>VITE_SUPABASE_ANON_KEY</code> antes de compilar.
        </p>

        <p>
          La guía completa está en <b>README.md</b> y el esquema de
          base de datos en{' '}
          <b>supabase/migrations/001_clientops.sql</b>.
        </p>
      </div>
    </div>
  )
}

function App() {
  const [session, setSession] = useState(null)
  const [profile, setProfile] = useState(null)
  const [authReady, setAuthReady] = useState(false)
  const [profileState, setProfileState] = useState('idle')

  useEffect(() => {
    if (!supabase) return

    let active = true

    supabase.auth.getSession().then(({ data }) => {
      if (!active) return

      setSession(data.session)
      setAuthReady(true)
    })

    const { data: listener } =
      supabase.auth.onAuthStateChange((_event, next) => {
        setSession(next)
        setProfile(null)
        setProfileState(next ? 'loading' : 'idle')
        setAuthReady(true)
      })

    return () => {
      active = false
      listener.subscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (!session) {
      setProfile(null)
      setProfileState('idle')
      return
    }

    let active = true

    async function loadProfile() {
      setProfileState('loading')

      const { data, error } = await supabase
        .from('clientops_profiles')
        .select('*')
        .eq('id', session.user.id)
        .maybeSingle()

      if (!active) return

      if (error) {
        console.error(
          'No se pudo cargar el perfil de ClientOps:',
          error,
        )

        setProfile(null)
        setProfileState('error')
        return
      }

      setProfile(data || null)
      setProfileState(data ? 'ready' : 'missing')
    }

    loadProfile()

    return () => {
      active = false
    }
  }, [session])

  if (!isSupabaseConfigured) {
    return <SetupRequired />
  }

  if (!authReady || (session && profileState === 'loading')) {
    return (
      <div className="center-loader">
        <img
          src="/assets/isotipo-verde.png"
          alt=""
        />

        <span>Cargando ClientOps…</span>
      </div>
    )
  }

  if (!session) {
    return <Login />
  }

  if (
    !profile &&
    ['missing', 'error'].includes(profileState)
  ) {
    return (
      <div className="setup-screen">
        <div className="setup-card">
          <h2>Tu perfil todavía no está listo</h2>

          <p>
            Verifica que exista un registro en{' '}
            <code>clientops_profiles</code> para este usuario y que las
            políticas permitan consultarlo.
          </p>

          <button
            className="btn primary"
            onClick={() => supabase.auth.signOut()}
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    )
  }

  if (!profile) {
    return (
      <div className="center-loader">
        <img
          src="/assets/isotipo-verde.png"
          alt=""
        />

        <span>Cargando ClientOps…</span>
      </div>
    )
  }

  return (
    <Workspace
      session={session}
      profile={profile}
    />
  )
}

function Workspace({ session, profile }) {
  const isTeam = ['superadmin', 'team'].includes(profile.role)

  const [view, setView] = useState(
    isTeam ? 'agency' : 'summary',
  )

  const [organizations, setOrganizations] = useState([])
  const [organizationId, setOrganizationId] = useState(
    profile.default_organization_id || '',
  )

  const [toast, setToast] = useState('')
  const [loadingOrgs, setLoadingOrgs] = useState(true)

  const loadOrganizations = useCallback(async () => {
    setLoadingOrgs(true)

    const { data, error } = await supabase
      .from('clientops_organizations')
      .select('*')
      .order('name')

    if (error) {
      setToast(error.message)
    } else {
      setOrganizations(data || [])

      if (!organizationId && data?.length && !isTeam) {
        setOrganizationId(data[0].id)
      }
    }

    setLoadingOrgs(false)
  }, [organizationId, isTeam])

  useEffect(() => {
    loadOrganizations()
  }, [loadOrganizations])

  useEffect(() => {
    if (!toast) return undefined

    const timeout = setTimeout(() => {
      setToast('')
    }, 5000)

    return () => clearTimeout(timeout)
  }, [toast])

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)

    if (query.get('connection') === 'success') {
      setToast(
        `Conexión ${query.get('provider') || ''} autorizada. Ahora pulsa Sincronizar.`,
      )
    }

    if (query.get('connection') === 'error') {
      setToast(
        query.get('message') ||
          'La conexión no pudo completarse.',
      )
    }

    if (query.has('connection')) {
      window.history.replaceState(
        {},
        '',
        window.location.pathname,
      )
    }
  }, [])

  const activeOrg = organizations.find(
    organization => organization.id === organizationId,
  )

  const nav = isTeam ? TEAM_NAV : CLIENT_NAV

  async function logout() {
    await supabase.auth.signOut()
  }

  const activeLabel =
    nav.find(([id]) => id === view)?.[1] || 'Resumen'

  const initials = (
    profile.full_name ||
    session.user.email ||
    'IL'
  )
    .split(/\s+/)
    .slice(0, 2)
    .map(part => part[0])
    .join('')
    .toUpperCase()

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <img
            src="/assets/isotipo-verde.png"
            alt="InsightLab"
          />

          <div>
            <strong>InsightLabOS</strong>
            <small>Hub ClientOps</small>
          </div>
        </div>

        <div className="workspace-switcher">
          <div className="workspace-switcher-icon">
            <Icon
              name="admin"
              size={18}
            />
          </div>

          <div>
            <b>InsightLab</b>

            <span>
              {isTeam ? 'Agencia · Activa' : 'Cuenta activa'}
            </span>
          </div>

          <Icon
            name="chevron"
            size={16}
          />
        </div>

        <div className="nav-label">PRINCIPAL</div>

        <nav>
          {nav.map(([id, label]) => (
            <button
              key={id}
              className={view === id ? 'active' : ''}
              onClick={() => setView(id)}
            >
              <span className="nav-icon">
                <Icon
                  name={id}
                  size={20}
                />
              </span>

              <span>{label}</span>
            </button>
          ))}
        </nav>

        <div className="sidebar-spacer" />

        <div className="secure-card">
          <span className="secure-dot" />

          <div>
            <b>Espacio protegido</b>
            <small>Acceso seguro por rol</small>
          </div>
        </div>

        <div className="user-card">
          <div className="user-avatar">{initials}</div>

          <div className="user-copy">
            <b>{profile.full_name || session.user.email}</b>

            <span>
              {isTeam
                ? 'Equipo InsightLab'
                : 'Portal del cliente'}
            </span>
          </div>

          <button
            className="sidebar-logout"
            onClick={logout}
            aria-label="Cerrar sesión"
            title="Cerrar sesión"
          >
            <Icon
              name="logout"
              size={18}
            />

            <span>Salir</span>
          </button>
        </div>
      </aside>

      <main className="workspace">
        <header className="topbar">
          <div className="breadcrumb">
            <span>ClientOps</span>
            <i>/</i>
            <b>{activeLabel}</b>
          </div>

          <label className="global-search">
            <Icon
              name="search"
              size={19}
            />

            <input placeholder="Buscar clientes, proyectos, leads o métricas…" />

            <kbd>/</kbd>
          </label>

          <div className="top-actions">
            {isTeam && (
              <select
                value={organizationId}
                onChange={event =>
                  setOrganizationId(event.target.value)
                }
                aria-label="Seleccionar cliente"
              >
                <option value="">Todos los clientes</option>

                {organizations.map(organization => (
                  <option
                    key={organization.id}
                    value={organization.id}
                  >
                    {organization.name}
                  </option>
                ))}
              </select>
            )}

            <button
              className="icon-button"
              aria-label="Notificaciones"
            >
              <Icon
                name="bell"
                size={20}
              />

              <span className="notification-dot">2</span>
            </button>

            <button
              className="icon-button top-logout"
              onClick={logout}
              aria-label="Cerrar sesión"
              title="Cerrar sesión"
            >
              <Icon
                name="logout"
                size={20}
              />
            </button>

            <button
              className="btn primary top-primary"
              onClick={() => setView('tasks')}
            >
              <Icon
                name="plus"
                size={18}
              />

              Nueva actividad
            </button>
          </div>
        </header>

        <div className="content">
          {loadingOrgs ? (
            <div className="page-loader">
              Cargando clientes…
            </div>
          ) : (
            <ViewRouter
              view={view}
              isTeam={isTeam}
              organizationId={organizationId}
              organizations={organizations}
              activeOrg={activeOrg}
              setOrganizationId={setOrganizationId}
              setToast={setToast}
              refreshOrganizations={loadOrganizations}
              session={session}
            />
          )}
        </div>
      </main>

      {toast && (
        <div className="toast">
          {toast}
        </div>
      )}
    </div>
  )
}

function ViewRouter(props) {
  const { view } = props

  if (view === 'agency') return <AgencyView {...props} />
  if (view === 'clients') return <ClientsView {...props} />
  if (view === 'connections') return <ConnectionsView {...props} />
  if (view === 'builder') return <BuilderView {...props} />
  if (view === 'summary') return <SummaryView {...props} />
  if (view === 'dashboard') return <DashboardView {...props} />
  if (view === 'goals') return <GoalsView {...props} />
  if (view === 'tasks') return <TasksView {...props} />
  if (view === 'meetings') return <MeetingsView {...props} />
  if (view === 'reports') return <ReportsView {...props} />
  if (view === 'admin') return <AdminView {...props} />

  return null
}

function PageTitle({
  eyebrow,
  title,
  description,
  action,
}) {
  return (
    <div className="page-title">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>

      {action}
    </div>
  )
}

function Empty({ title, text }) {
  return (
    <div className="empty">
      <img
        src="/assets/isotipo-verde.png"
        alt=""
      />

      <h3>{title}</h3>
      <p>{text}</p>
    </div>
  )
}

function Status({ value }) {
  const normalizedValue = String(value).replaceAll('_', '-')
  const label = String(value).replaceAll('_', ' ')

  return (
    <span className={`status status-${normalizedValue}`}>
      {label}
    </span>
  )
}

function AgencyView({ organizations }) {
  const [stats, setStats] = useState({
    connections: 0,
    pending: 0,
    goals: 0,
    meetings: 0,
  })

  const [tasks, setTasks] = useState([])
  const [meetings, setMeetings] = useState([])

  useEffect(() => {
    async function loadAgencyData() {
      const [
        connectionResult,
        taskCountResult,
        goalResult,
        meetingCountResult,
        taskRows,
        meetingRows,
      ] = await Promise.all([
        supabase
          .from('clientops_connections')
          .select('*', {
            count: 'exact',
            head: true,
          })
          .eq('status', 'connected'),

        supabase
          .from('clientops_tasks')
          .select('*', {
            count: 'exact',
            head: true,
          })
          .neq('status', 'completed'),

        supabase
          .from('clientops_goals')
          .select('*', {
            count: 'exact',
            head: true,
          }),

        supabase
          .from('clientops_meetings')
          .select('*', {
            count: 'exact',
            head: true,
          })
          .gte('starts_at', new Date().toISOString()),

        supabase
          .from('clientops_tasks')
          .select('*')
          .neq('status', 'completed')
          .order('due_date')
          .limit(5),

        supabase
          .from('clientops_meetings')
          .select('*')
          .gte('starts_at', new Date().toISOString())
          .order('starts_at')
          .limit(3),
      ])

      setStats({
        connections: connectionResult.count || 0,
        pending: taskCountResult.count || 0,
        goals: goalResult.count || 0,
        meetings: meetingCountResult.count || 0,
      })

      setTasks(taskRows.data || [])
      setMeetings(meetingRows.data || [])
    }

    loadAgencyData()
  }, [])

  const activeClients = organizations.filter(
    organization => organization.status === 'active',
  ).length

  const attention = stats.pending + stats.meetings

  const todayLabel = new Intl.DateTimeFormat('es-CO', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  })
    .format(new Date())
    .toUpperCase()

  return (
    <>
      <PageTitle
        eyebrow={todayLabel}
        title="Dashboard general"
        description="Consulta el pulso de la operación, los clientes y los compromisos activos de InsightLab."
      />

      <section className="hero-summary">
        <div className="hero-icon">
          <Icon
            name="trend"
            size={25}
          />
        </div>

        <div className="hero-copy">
          <span>Foco operativo</span>

          <h2>
            {attention || activeClients} elementos requieren
            seguimiento.
          </h2>

          <p>
            {activeClients} clientes activos · {stats.connections}{' '}
            conexiones operativas · {stats.goals} objetivos
            registrados
          </p>
        </div>

        <div className="hero-stat">
          <strong>{activeClients}</strong>
          <span>clientes activos</span>
        </div>
      </section>

      <div className="metric-grid agency-metrics">
        <MetricCard
          icon="clients"
          label="Clientes activos"
          value={activeClients}
          note="Organizaciones con acceso"
          trend="Operación vigente"
        />

        <MetricCard
          icon="connections"
          label="Conexiones activas"
          value={stats.connections}
          note="Plataformas enlazadas"
          trend="Datos disponibles"
        />

        <MetricCard
          icon="tasks"
          label="Actividades pendientes"
          value={stats.pending}
          note="Todas las cuentas"
          trend={
            stats.pending
              ? 'Requieren seguimiento'
              : 'Todo al día'
          }
        />

        <MetricCard
          icon="calendar"
          label="Próximas reuniones"
          value={stats.meetings}
          note="Agendadas"
          trend="Agenda actualizada"
        />
      </div>

      <div className="dashboard-layout">
        <div className="card dashboard-main-card">
          <div className="card-head">
            <div>
              <h3>Clientes</h3>
              <p>
                Estado general de las cuentas administradas.
              </p>
            </div>

            <span className="count-pill">
              {organizations.length} cuentas
            </span>
          </div>

          {organizations.length ? (
            <div className="table-list client-table">
              {organizations.map(organization => (
                <div
                  className="table-row"
                  key={organization.id}
                >
                  <div className="avatar">
                    {organization.name.slice(0, 2).toUpperCase()}
                  </div>

                  <div className="grow">
                    <b>{organization.name}</b>
                    <small>{organization.slug}</small>
                  </div>

                  <div className="account-meta">
                    <span>Dashboard</span>
                    <small>Listo para configurar</small>
                  </div>

                  <Status value={organization.status} />
                </div>
              ))}
            </div>
          ) : (
            <Empty
              title="Todavía no hay clientes"
              text="Crea la primera organización desde el módulo Clientes."
            />
          )}
        </div>

        <div className="dashboard-side-stack">
          <div className="card">
            <div className="card-head">
              <div>
                <h3>Próximas tareas</h3>
                <p>{stats.pending} actividades abiertas</p>
              </div>
            </div>

            {tasks.length ? (
              <div className="table-list compact-list">
                {tasks.map(task => (
                  <div
                    className="table-row"
                    key={task.id}
                  >
                    <span className="check-box" />

                    <div className="grow">
                      <b>{task.title}</b>
                      <small>{dateText(task.due_date)}</small>
                    </div>

                    <Status
                      value={task.priority || task.status}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <p className="muted">
                No hay actividades pendientes.
              </p>
            )}
          </div>

          <div className="card">
            <div className="card-head">
              <div>
                <h3>Próximas reuniones</h3>
                <p>Agenda compartida con clientes</p>
              </div>
            </div>

            {meetings.length ? (
              <div className="meeting-list">
                {meetings.map(meeting => (
                  <article key={meeting.id}>
                    <time>{dateText(meeting.starts_at)}</time>

                    <div>
                      <b>{meeting.title}</b>

                      <span>
                        {new Intl.DateTimeFormat('es-CO', {
                          hour: 'numeric',
                          minute: '2-digit',
                        }).format(
                          new Date(meeting.starts_at),
                        )}
                      </span>
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <p className="muted">
                No hay reuniones próximas.
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

function MetricCard({
  label,
  value,
  note,
  trend,
  icon = 'trend',
}) {
  return (
    <article className="metric-card">
      <div className="metric-icon">
        <Icon
          name={icon}
          size={21}
        />
      </div>

      <div className="metric-copy">
        <span>{label}</span>
        <strong>{value}</strong>
        <small>{note}</small>

        {trend && <em>↗ {trend}</em>}
      </div>
    </article>
  )
}

function ClientsView({
  organizations,
  organizationId,
  refreshOrganizations,
  setOrganizationId,
  setToast,
}) {
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [busy, setBusy] = useState(false)

  const [invite, setInvite] = useState({
    full_name: '',
    email: '',
  })

  const [inviting, setInviting] = useState(false)

  async function add(event) {
    event.preventDefault()
    setBusy(true)

    const cleanSlug =
      slug ||
      name
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '')

    const { data, error } = await supabase
      .from('clientops_organizations')
      .insert({
        name,
        slug: cleanSlug,
      })
      .select()
      .single()

    setBusy(false)

    if (error) {
      setToast(error.message)
      return
    }

    setName('')
    setSlug('')

    await refreshOrganizations()

    setOrganizationId(data.id)
    setToast('Cliente creado.')
  }

  async function inviteUser(event) {
    event.preventDefault()

    if (!organizationId) {
      setToast(
        'Selecciona el cliente al que pertenece el usuario.',
      )
      return
    }

    setInviting(true)

    const {
      data: { session: current },
    } = await supabase.auth.getSession()

    const response = await fetch('/api/users/invite', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${current.access_token}`,
      },
      body: JSON.stringify({
        ...invite,
        organization_id: organizationId,
      }),
    })

    const body = await response.json().catch(() => ({}))

    setInviting(false)

    if (!response.ok) {
      setToast(
        body.error ||
          'No fue posible invitar al usuario.',
      )
      return
    }

    setInvite({
      full_name: '',
      email: '',
    })

    setToast(
      'Invitación enviada. El cliente podrá crear su contraseña.',
    )
  }

  return (
    <>
      <PageTitle
        eyebrow="CLIENTES"
        title="Cuentas, marcas y accesos"
        description="Cada cliente tiene su propia organización, usuarios y dashboard privado."
      />

      <div className="two-col">
        <div>
          <div className="card">
            <h3>Nuevo cliente</h3>

            <form
              className="form"
              onSubmit={add}
            >
              <label>
                Nombre

                <input
                  value={name}
                  onChange={event =>
                    setName(event.target.value)
                  }
                  required
                />
              </label>

              <label>
                Identificador opcional

                <input
                  value={slug}
                  onChange={event =>
                    setSlug(event.target.value)
                  }
                  placeholder="fuego-burger"
                />
              </label>

              <button
                className="btn primary"
                disabled={busy}
              >
                {busy ? 'Creando…' : 'Crear cliente'}
              </button>
            </form>
          </div>

          <div className="card">
            <h3>Invitar usuario del cliente</h3>

            <p className="muted">
              Selecciona una cuenta en la lista o en el selector
              superior. Supabase enviará el enlace para crear la
              contraseña mediante Brevo SMTP.
            </p>

            <form
              className="form"
              onSubmit={inviteUser}
            >
              <label>
                Nombre completo

                <input
                  value={invite.full_name}
                  onChange={event =>
                    setInvite({
                      ...invite,
                      full_name: event.target.value,
                    })
                  }
                  required
                />
              </label>

              <label>
                Correo electrónico

                <input
                  type="email"
                  value={invite.email}
                  onChange={event =>
                    setInvite({
                      ...invite,
                      email: event.target.value,
                    })
                  }
                  required
                />
              </label>

              <button
                className="btn primary"
                disabled={inviting || !organizationId}
              >
                {inviting
                  ? 'Enviando…'
                  : 'Enviar invitación'}
              </button>
            </form>
          </div>
        </div>

        <div className="card">
          <h3>Clientes registrados</h3>

          {organizations.length ? (
            <div className="table-list">
              {organizations.map(organization => (
                <button
                  className={`table-row clickable ${
                    organizationId === organization.id
                      ? 'selected-row'
                      : ''
                  }`}
                  key={organization.id}
                  onClick={() =>
                    setOrganizationId(organization.id)
                  }
                >
                  <div className="avatar">
                    {organization.name
                      .slice(0, 2)
                      .toUpperCase()}
                  </div>

                  <div className="grow">
                    <b>{organization.name}</b>
                    <small>{organization.slug}</small>
                  </div>

                  <Status value={organization.status} />
                </button>
              ))}
            </div>
          ) : (
            <Empty
              title="Sin clientes"
              text="Crea una organización para comenzar."
            />
          )}
        </div>
      </div>
    </>
  )
}

function ConnectionsView({
  organizationId,
  activeOrg,
  setToast,
}) {
  const [connections, setConnections] = useState([])
  const [busy, setBusy] = useState('')

  const load = useCallback(async () => {
    if (!organizationId) {
      setConnections([])
      return
    }

    const {
      data: { session: current },
    } = await supabase.auth.getSession()

    if (!current?.access_token) {
      setToast('La sesión no es válida o expiró.')
      return
    }

    const query = new URLSearchParams({
      organization_id: organizationId,
    })

    const response = await fetch(
      `/api/connections/list?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${current.access_token}`,
        },
      },
    )

    const body = await response.json().catch(() => ({}))

    if (!response.ok) {
      setToast(
        body.error ||
          'No fue posible cargar las conexiones.',
      )
    } else {
      setConnections(body.connections || [])
    }
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  async function connect(provider) {
    if (!organizationId) {
      setToast('Selecciona primero un cliente.')
      return
    }

    let shop = ''

    if (provider === 'shopify') {
      shop =
        window.prompt(
          'Escribe el dominio de Shopify, por ejemplo tienda.myshopify.com',
        ) || ''

      if (!shop) return
    }

    setBusy(provider)

    const {
      data: { session: current },
    } = await supabase.auth.getSession()

    if (!current?.access_token) {
      setBusy('')
      setToast('La sesión no es válida o expiró.')
      return
    }

    const query = new URLSearchParams({
      organization_id: organizationId,
    })

    if (shop) {
      query.set('shop', shop)
    }

    const response = await fetch(
      `/api/oauth/${provider}/start?${query.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${current.access_token}`,
        },
      },
    )

    const body = await response.json().catch(() => ({}))

    setBusy('')

    if (!response.ok) {
      setToast(
        body.error ||
          'No fue posible iniciar la conexión.',
      )
      return
    }

    window.location.href = body.url
  }

  async function sync(id) {
    setBusy(id)

    const {
      data: { session: current },
    } = await supabase.auth.getSession()

    if (!current?.access_token) {
      setBusy('')
      setToast('La sesión no es válida o expiró.')
      return
    }

    const response = await fetch('/api/connections/sync', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${current.access_token}`,
      },
      body: JSON.stringify({
        connection_id: id,
      }),
    })

    const body = await response.json().catch(() => ({}))

    setBusy('')

    setToast(
      response.ok
        ? body.message || 'Sincronización iniciada.'
        : body.error || 'Error de sincronización',
    )

    if (response.ok) {
      load()
    }
  }

  return (
    <>
      <PageTitle
        eyebrow="CONEXIONES"
        title={
          activeOrg
            ? `Plataformas de ${activeOrg.name}`
            : 'Selecciona un cliente'
        }
        description="Autoriza cada plataforma desde su flujo oficial. Las claves privadas permanecen en Cloudflare."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="Elige un cliente en el selector superior antes de conectar una plataforma."
        />
      ) : (
        <div className="provider-grid">
          {PROVIDERS.map(provider => {
            const connection = connections.find(
              item => item.provider === provider.id,
            )

            return (
              <div
                className="provider-card"
                key={provider.id}
              >
                <div
                  className={`provider-icon ${provider.id}`}
                >
                  {provider.icon}
                </div>

                <div className="grow">
                  <h3>{provider.name}</h3>
                  <p>{provider.detail}</p>

                  {connection && (
                    <small>
                      {connection.external_account_name ||
                        connection.external_account_id ||
                        'Conexión autorizada'}{' '}
                      ·{' '}
                      {connection.last_synced_at
                        ? `Sincronizado ${dateText(
                            connection.last_synced_at,
                          )}`
                        : 'Sin sincronizar'}
                    </small>
                  )}
                </div>

                <Status
                  value={
                    connection?.status || 'not_connected'
                  }
                />

                {connection ? (
                  <button
                    className="btn soft"
                    onClick={() => sync(connection.id)}
                    disabled={busy === connection.id}
                  >
                    {busy === connection.id
                      ? 'Sincronizando…'
                      : 'Sincronizar'}
                  </button>
                ) : (
                  <button
                    className="btn primary"
                    onClick={() => connect(provider.id)}
                    disabled={busy === provider.id}
                  >
                    {busy === provider.id
                      ? 'Abriendo…'
                      : 'Conectar'}
                  </button>
                )}
              </div>
            )
          })}
        </div>
      )}
    </>
  )
}

function useWidgets(organizationId, setToast) {
  const [catalog, setCatalog] = useState([])
  const [widgets, setWidgets] = useState([])

  const load = useCallback(async () => {
    if (!organizationId) {
      setWidgets([])
      return
    }

    const [catalogResult, widgetResult] =
      await Promise.all([
        supabase
          .from('clientops_metric_catalog')
          .select('*')
          .eq('is_active', true)
          .order('source')
          .order('label'),

        supabase
          .from('clientops_dashboard_widgets')
          .select(
            '*, metric:clientops_metric_catalog(*)',
          )
          .eq('organization_id', organizationId)
          .order('position'),
      ])

    if (catalogResult.error) {
      setToast(catalogResult.error.message)
    } else {
      setCatalog(catalogResult.data || [])
    }

    if (widgetResult.error) {
      setToast(widgetResult.error.message)
    } else {
      setWidgets(widgetResult.data || [])
    }
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  return {
    catalog,
    widgets,
    setWidgets,
    load,
  }
}

function BuilderView({
  organizationId,
  activeOrg,
  setToast,
}) {
  const {
    catalog,
    widgets,
    setWidgets,
    load,
  } = useWidgets(organizationId, setToast)

  const [search, setSearch] = useState('')
  const [source, setSource] = useState('all')
  const [drag, setDrag] = useState(null)

  const filtered = useMemo(
    () =>
      catalog.filter(metric => {
        const matchesSource =
          source === 'all' || metric.source === source

        const searchable = `${metric.label} ${metric.metric_key} ${metric.category}`.toLowerCase()

        return (
          matchesSource &&
          searchable.includes(search.toLowerCase())
        )
      }),
    [catalog, search, source],
  )

  async function add(metric) {
    if (
      widgets.some(
        widget => widget.metric_id === metric.id,
      )
    ) {
      setToast(
        'Ese indicador ya está en el dashboard.',
      )
      return
    }

    const { error } = await supabase
      .from('clientops_dashboard_widgets')
      .insert({
        organization_id: organizationId,
        metric_id: metric.id,
        title: metric.label,
        position: widgets.length,
      })

    if (error) {
      setToast(error.message)
    } else {
      load()
    }
  }

  async function remove(id) {
    const { error } = await supabase
      .from('clientops_dashboard_widgets')
      .delete()
      .eq('id', id)

    if (error) {
      setToast(error.message)
    } else {
      load()
    }
  }

  async function persist(next) {
    setWidgets(next)

    await Promise.all(
      next.map((widget, index) =>
        supabase
          .from('clientops_dashboard_widgets')
          .update({
            position: index,
          })
          .eq('id', widget.id),
      ),
    )

    setToast('Orden del dashboard guardado.')
  }

  function drop(target) {
    if (drag === null || drag === target) return

    const next = [...widgets]
    const [item] = next.splice(drag, 1)

    next.splice(target, 0, item)

    setDrag(null)
    persist(next)
  }

  return (
    <>
      <PageTitle
        eyebrow="DASHBOARD Y MÉTRICAS"
        title={
          activeOrg
            ? `Configurar dashboard de ${activeOrg.name}`
            : 'Selecciona un cliente'
        }
        description="Agrega indicadores de las plataformas y arrastra las tarjetas para definir el orden que verá el cliente."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="Cada cliente tiene una configuración de dashboard independiente."
        />
      ) : (
        <div className="builder-layout">
          <div className="card library">
            <div className="card-head">
              <div>
                <h3>Biblioteca de indicadores</h3>

                <p>
                  El catálogo crecerá con las métricas
                  descubiertas en cada API.
                </p>
              </div>
            </div>

            <div className="filters">
              <input
                placeholder="Buscar indicador…"
                value={search}
                onChange={event =>
                  setSearch(event.target.value)
                }
              />

              <select
                value={source}
                onChange={event =>
                  setSource(event.target.value)
                }
              >
                <option value="all">
                  Todas las fuentes
                </option>

                {[...new Set(catalog.map(metric => metric.source))].map(
                  item => (
                    <option key={item}>
                      {item}
                    </option>
                  ),
                )}
              </select>
            </div>

            <div className="metric-library">
              {filtered.map(metric => (
                <button
                  key={metric.id}
                  onClick={() => add(metric)}
                >
                  <div>
                    <b>{metric.label}</b>

                    <small>
                      {metric.source} · {metric.category}
                    </small>
                  </div>

                  <span>＋</span>
                </button>
              ))}
            </div>
          </div>

          <div className="card canvas">
            <div className="card-head">
              <div>
                <h3>Tarjetas del dashboard</h3>

                <p>
                  Mantén presionada una tarjeta y muévela a la
                  posición deseada.
                </p>
              </div>

              <span className="count-pill">
                {widgets.length} métricas
              </span>
            </div>

            {widgets.length ? (
              <div className="sortable-grid">
                {widgets.map((widget, index) => (
                  <article
                    key={widget.id}
                    draggable
                    onDragStart={() => setDrag(index)}
                    onDragOver={event =>
                      event.preventDefault()
                    }
                    onDrop={() => drop(index)}
                    className="sortable-card"
                  >
                    <div className="drag-handle">⋮⋮</div>

                    <span>{widget.metric?.source}</span>

                    <strong>{widget.title}</strong>

                    <small>
                      {widget.metric?.description ||
                        widget.metric?.metric_key}
                    </small>

                    <button
                      onClick={() => remove(widget.id)}
                      aria-label="Eliminar"
                    >
                      ×
                    </button>
                  </article>
                ))}
              </div>
            ) : (
              <Empty
                title="Dashboard vacío"
                text="Agrega indicadores desde la biblioteca de la izquierda."
              />
            )}
          </div>
        </div>
      )}
    </>
  )
}

function SummaryView({
  organizationId,
  activeOrg,
  setToast,
}) {
  return (
    <>
      <PageTitle
        eyebrow="RESUMEN EJECUTIVO"
        title={activeOrg?.name || 'Mi cuenta'}
        description="Los resultados y compromisos más importantes de la operación."
      />

      <DashboardCore
        organizationId={organizationId}
        setToast={setToast}
        compact
      />

      <div className="two-col">
        <GoalsPreview organizationId={organizationId} />
        <TasksPreview organizationId={organizationId} />
      </div>
    </>
  )
}

function DashboardView({
  organizationId,
  activeOrg,
  setToast,
}) {
  return (
    <>
      <PageTitle
        eyebrow="DASHBOARD"
        title={`Resultados de ${
          activeOrg?.name || 'la cuenta'
        }`}
        description="Información publicada por InsightLab a partir de las plataformas conectadas."
      />

      <DashboardCore
        organizationId={organizationId}
        setToast={setToast}
      />
    </>
  )
}

function DashboardCore({
  organizationId,
  setToast,
  compact = false,
}) {
  const { widgets } = useWidgets(
    organizationId,
    setToast,
  )

  const [values, setValues] = useState([])

  useEffect(() => {
    if (!organizationId || !widgets.length) {
      setValues([])
      return
    }

    const keys = widgets
      .map(widget => widget.metric?.metric_key)
      .filter(Boolean)

    const from = new Date(
      Date.now() - 60 * 86400000,
    )
      .toISOString()
      .slice(0, 10)

    supabase
      .from('clientops_metric_values')
      .select('*')
      .eq('organization_id', organizationId)
      .in('metric_key', keys)
      .gte('metric_date', from)
      .then(({ data, error }) => {
        if (error) {
          setToast(error.message)
        } else {
          setValues(data || [])
        }
      })
  }, [organizationId, widgets, setToast])

  const cards = widgets
    .slice(0, compact ? 4 : widgets.length)
    .map(widget => {
      const metric = widget.metric

      const rows = values.filter(
        item => item.metric_key === metric?.metric_key,
      )

      const cutoff = Date.now() - 30 * 86400000

      const current = rows.filter(
        item =>
          new Date(item.metric_date).getTime() >= cutoff,
      )

      let value = 0

      if (metric?.aggregation === 'avg') {
        value = current.length
          ? current.reduce(
              (total, item) =>
                total + Number(item.value),
              0,
            ) / current.length
          : 0
      } else if (metric?.aggregation === 'latest') {
        value =
          current.sort((a, b) =>
            String(b.metric_date).localeCompare(
              String(a.metric_date),
            ),
          )[0]?.value || 0
      } else {
        value = current.reduce(
          (total, item) =>
            total + Number(item.value),
          0,
        )
      }

      return {
        ...widget,
        value,
        has: current.length > 0,
      }
    })

  return cards.length ? (
    <div className="metric-grid">
      {cards.map(card => (
        <MetricCard
          key={card.id}
          label={card.title}
          value={
            card.has
              ? formatValue(
                  card.value,
                  card.metric?.unit,
                  card.metric?.currency || 'COP',
                )
              : 'Sin datos'
          }
          note={`${card.metric?.source || ''} · últimos 30 días`}
        />
      ))}
    </div>
  ) : (
    <Empty
      title="Dashboard sin configurar"
      text="InsightLab todavía no ha publicado indicadores para esta cuenta."
    />
  )
}

function GoalsPreview({ organizationId }) {
  const [items, setItems] = useState([])

  useEffect(() => {
    if (!organizationId) return

    supabase
      .from('clientops_goals')
      .select('*')
      .eq('organization_id', organizationId)
      .order('end_date')
      .limit(3)
      .then(({ data }) => {
        setItems(data || [])
      })
  }, [organizationId])

  return (
    <div className="card">
      <h3>Objetivos</h3>

      {items.length ? (
        items.map(item => (
          <ProgressRow
            key={item.id}
            item={item}
          />
        ))
      ) : (
        <p className="muted">
          No hay objetivos publicados.
        </p>
      )}
    </div>
  )
}

function TasksPreview({ organizationId }) {
  const [items, setItems] = useState([])

  useEffect(() => {
    if (!organizationId) return

    supabase
      .from('clientops_tasks')
      .select('*')
      .eq('organization_id', organizationId)
      .neq('status', 'completed')
      .order('due_date')
      .limit(4)
      .then(({ data }) => {
        setItems(data || [])
      })
  }, [organizationId])

  return (
    <div className="card">
      <h3>Próximas actividades</h3>

      {items.length ? (
        <div className="table-list">
          {items.map(item => (
            <div
              className="table-row"
              key={item.id}
            >
              <div className="task-dot" />

              <div className="grow">
                <b>{item.title}</b>
                <small>{dateText(item.due_date)}</small>
              </div>

              <Status value={item.status} />
            </div>
          ))}
        </div>
      ) : (
        <p className="muted">
          No hay actividades pendientes.
        </p>
      )}
    </div>
  )
}

function ProgressRow({ item }) {
  const percentage = Math.min(
    100,
    Math.round(
      (Number(item.current_value || 0) /
        Math.max(Number(item.target_value || 1), 1)) *
        100,
    ),
  )

  return (
    <div className="progress-row">
      <div>
        <b>{item.title}</b>

        <span>
          {formatValue(
            item.current_value,
            item.unit,
          )}{' '}
          de{' '}
          {formatValue(
            item.target_value,
            item.unit,
          )}
        </span>
      </div>

      <div className="progress">
        <i
          style={{
            width: `${percentage}%`,
          }}
        />
      </div>

      <strong>{percentage}%</strong>
    </div>
  )
}

function GoalsView({
  organizationId,
  isTeam,
  setToast,
}) {
  const [items, setItems] = useState([])

  const [form, setForm] = useState({
    title: '',
    target_value: '',
    current_value: '',
    unit: 'number',
    end_date: '',
  })

  const load = useCallback(() => {
    if (!organizationId) {
      setItems([])
      return
    }

    supabase
      .from('clientops_goals')
      .select('*')
      .eq('organization_id', organizationId)
      .order('end_date')
      .then(({ data, error }) => {
        if (error) {
          setToast(error.message)
        } else {
          setItems(data || [])
        }
      })
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  async function add(event) {
    event.preventDefault()

    const { error } = await supabase
      .from('clientops_goals')
      .insert({
        ...form,
        organization_id: organizationId,
        target_value: Number(form.target_value),
        current_value: Number(
          form.current_value || 0,
        ),
      })

    if (error) {
      setToast(error.message)
      return
    }

    setForm({
      title: '',
      target_value: '',
      current_value: '',
      unit: 'number',
      end_date: '',
    })

    load()
  }

  return (
    <>
      <PageTitle
        eyebrow="OBJETIVOS"
        title="Metas y cumplimiento"
        description="Seguimiento de los resultados acordados con el cliente."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="Los objetivos pertenecen a una organización."
        />
      ) : (
        <div className="two-col">
          {isTeam && (
            <div className="card">
              <h3>Crear objetivo</h3>

              <form
                className="form"
                onSubmit={add}
              >
                <label>
                  Objetivo

                  <input
                    value={form.title}
                    onChange={event =>
                      setForm({
                        ...form,
                        title: event.target.value,
                      })
                    }
                    required
                  />
                </label>

                <div className="form-row">
                  <label>
                    Meta

                    <input
                      type="number"
                      step="any"
                      value={form.target_value}
                      onChange={event =>
                        setForm({
                          ...form,
                          target_value:
                            event.target.value,
                        })
                      }
                      required
                    />
                  </label>

                  <label>
                    Resultado actual

                    <input
                      type="number"
                      step="any"
                      value={form.current_value}
                      onChange={event =>
                        setForm({
                          ...form,
                          current_value:
                            event.target.value,
                        })
                      }
                    />
                  </label>
                </div>

                <div className="form-row">
                  <label>
                    Unidad

                    <select
                      value={form.unit}
                      onChange={event =>
                        setForm({
                          ...form,
                          unit: event.target.value,
                        })
                      }
                    >
                      <option value="number">
                        Número
                      </option>

                      <option value="currency">
                        Dinero
                      </option>

                      <option value="percent">
                        Porcentaje
                      </option>
                    </select>
                  </label>

                  <label>
                    Fecha límite

                    <input
                      type="date"
                      value={form.end_date}
                      onChange={event =>
                        setForm({
                          ...form,
                          end_date: event.target.value,
                        })
                      }
                    />
                  </label>
                </div>

                <button className="btn primary">
                  Guardar objetivo
                </button>
              </form>
            </div>
          )}

          <div className="card span-if-client">
            <h3>Objetivos activos</h3>

            {items.length ? (
              items.map(item => (
                <ProgressRow
                  key={item.id}
                  item={item}
                />
              ))
            ) : (
              <Empty
                title="Sin objetivos"
                text="Todavía no hay objetivos registrados para esta cuenta."
              />
            )}
          </div>
        </div>
      )}
    </>
  )
}

function TasksView({
  organizationId,
  isTeam,
  setToast,
}) {
  const [items, setItems] = useState([])

  const [form, setForm] = useState({
    title: '',
    description: '',
    status: 'todo',
    due_date: '',
    visible_to_client: true,
  })

  const load = useCallback(() => {
    if (!organizationId) {
      setItems([])
      return
    }

    supabase
      .from('clientops_tasks')
      .select('*')
      .eq('organization_id', organizationId)
      .order('position')
      .order('due_date')
      .then(({ data, error }) => {
        if (error) {
          setToast(error.message)
        } else {
          setItems(data || [])
        }
      })
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  async function add(event) {
    event.preventDefault()

    const { error } = await supabase
      .from('clientops_tasks')
      .insert({
        ...form,
        organization_id: organizationId,
        position: items.length,
      })

    if (error) {
      setToast(error.message)
      return
    }

    setForm({
      title: '',
      description: '',
      status: 'todo',
      due_date: '',
      visible_to_client: true,
    })

    load()
  }

  async function change(id, status) {
    const { error } = await supabase
      .from('clientops_tasks')
      .update({
        status,
      })
      .eq('id', id)

    if (error) {
      setToast(error.message)
    } else {
      load()
    }
  }

  const columns = [
    'todo',
    'in_progress',
    'review',
    'completed',
  ]

  return (
    <>
      <PageTitle
        eyebrow="ACTIVIDADES"
        title="Pipeline de trabajo"
        description="El cliente ve el avance de las tareas que InsightLab haya marcado como visibles."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="Las actividades pertenecen a un cliente."
        />
      ) : (
        <>
          {isTeam && (
            <div className="card compact-form">
              <form
                className="inline-form"
                onSubmit={add}
              >
                <input
                  placeholder="Nueva actividad"
                  value={form.title}
                  onChange={event =>
                    setForm({
                      ...form,
                      title: event.target.value,
                    })
                  }
                  required
                />

                <input
                  type="date"
                  value={form.due_date}
                  onChange={event =>
                    setForm({
                      ...form,
                      due_date: event.target.value,
                    })
                  }
                />

                <select
                  value={form.status}
                  onChange={event =>
                    setForm({
                      ...form,
                      status: event.target.value,
                    })
                  }
                >
                  {columns.map(column => (
                    <option
                      key={column}
                      value={column}
                    >
                      {column.replace('_', ' ')}
                    </option>
                  ))}
                </select>

                <button className="btn primary">
                  Agregar
                </button>
              </form>
            </div>
          )}

          <div className="kanban">
            {columns.map(column => (
              <div
                className="kanban-col"
                key={column}
              >
                <div className="kanban-head">
                  <b>{column.replace('_', ' ')}</b>

                  <span>
                    {
                      items.filter(
                        item => item.status === column,
                      ).length
                    }
                  </span>
                </div>

                {items
                  .filter(
                    item => item.status === column,
                  )
                  .map(item => (
                    <article
                      className="task-card"
                      key={item.id}
                    >
                      <b>{item.title}</b>
                      <p>{item.description}</p>
                      <small>{dateText(item.due_date)}</small>

                      {isTeam && (
                        <select
                          value={item.status}
                          onChange={event =>
                            change(
                              item.id,
                              event.target.value,
                            )
                          }
                        >
                          {columns.map(nextColumn => (
                            <option
                              key={nextColumn}
                              value={nextColumn}
                            >
                              {nextColumn.replace(
                                '_',
                                ' ',
                              )}
                            </option>
                          ))}
                        </select>
                      )}
                    </article>
                  ))}
              </div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

function MeetingsView({
  organizationId,
  isTeam,
  setToast,
}) {
  const [items, setItems] = useState([])

  const [form, setForm] = useState({
    title: '',
    starts_at: '',
    agenda: '',
    minutes: '',
    visible_to_client: true,
  })

  const load = useCallback(() => {
    if (!organizationId) {
      setItems([])
      return
    }

    supabase
      .from('clientops_meetings')
      .select('*')
      .eq('organization_id', organizationId)
      .order('starts_at', {
        ascending: false,
      })
      .then(({ data, error }) => {
        if (error) {
          setToast(error.message)
        } else {
          setItems(data || [])
        }
      })
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  async function add(event) {
    event.preventDefault()

    const { error } = await supabase
      .from('clientops_meetings')
      .insert({
        ...form,
        organization_id: organizationId,
      })

    if (error) {
      setToast(error.message)
      return
    }

    setForm({
      title: '',
      starts_at: '',
      agenda: '',
      minutes: '',
      visible_to_client: true,
    })

    load()
  }

  return (
    <>
      <PageTitle
        eyebrow="REUNIONES"
        title="Agendas y actas"
        description="Consulta próximas reuniones y conserva el historial de acuerdos."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="Las reuniones pertenecen a un cliente."
        />
      ) : (
        <div className="two-col">
          {isTeam && (
            <div className="card">
              <h3>Nueva reunión</h3>

              <form
                className="form"
                onSubmit={add}
              >
                <label>
                  Título

                  <input
                    value={form.title}
                    onChange={event =>
                      setForm({
                        ...form,
                        title: event.target.value,
                      })
                    }
                    required
                  />
                </label>

                <label>
                  Fecha y hora

                  <input
                    type="datetime-local"
                    value={form.starts_at}
                    onChange={event =>
                      setForm({
                        ...form,
                        starts_at: event.target.value,
                      })
                    }
                    required
                  />
                </label>

                <label>
                  Agenda

                  <textarea
                    value={form.agenda}
                    onChange={event =>
                      setForm({
                        ...form,
                        agenda: event.target.value,
                      })
                    }
                  />
                </label>

                <label>
                  Acta / acuerdos

                  <textarea
                    value={form.minutes}
                    onChange={event =>
                      setForm({
                        ...form,
                        minutes: event.target.value,
                      })
                    }
                  />
                </label>

                <button className="btn primary">
                  Guardar reunión
                </button>
              </form>
            </div>
          )}

          <div className="card span-if-client">
            <h3>Historial</h3>

            {items.length ? (
              <div className="timeline">
                {items.map(item => (
                  <article key={item.id}>
                    <time>
                      {dateText(item.starts_at)}
                    </time>

                    <div>
                      <b>{item.title}</b>

                      {item.agenda && (
                        <p>
                          <strong>Agenda:</strong>{' '}
                          {item.agenda}
                        </p>
                      )}

                      {item.minutes && (
                        <p>
                          <strong>Acta:</strong>{' '}
                          {item.minutes}
                        </p>
                      )}
                    </div>
                  </article>
                ))}
              </div>
            ) : (
              <Empty
                title="Sin reuniones"
                text="No hay reuniones registradas."
              />
            )}
          </div>
        </div>
      )}
    </>
  )
}

function ReportsView({
  organizationId,
  isTeam,
  setToast,
}) {
  const [items, setItems] = useState([])
  const [name, setName] = useState('')

  const load = useCallback(() => {
    if (!organizationId) {
      setItems([])
      return
    }

    supabase
      .from('clientops_reports')
      .select('*')
      .eq('organization_id', organizationId)
      .order('created_at', {
        ascending: false,
      })
      .then(({ data, error }) => {
        if (error) {
          setToast(error.message)
        } else {
          setItems(data || [])
        }
      })
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  async function add(event) {
    event.preventDefault()

    const { error } = await supabase
      .from('clientops_reports')
      .insert({
        organization_id: organizationId,
        name,
        status: 'draft',
        sections: [],
      })

    if (error) {
      setToast(error.message)
      return
    }

    setName('')
    load()
  }

  async function publish(id) {
    const { error } = await supabase
      .from('clientops_reports')
      .update({
        status: 'published',
        published_at: new Date().toISOString(),
      })
      .eq('id', id)

    if (error) {
      setToast(error.message)
    } else {
      load()
    }
  }

  return (
    <>
      <PageTitle
        eyebrow="REPORTES"
        title="Reportes de resultados"
        description="Publica reportes periódicos sin permitir que el cliente modifique su configuración."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="Cada reporte pertenece a un cliente."
        />
      ) : (
        <div className="card">
          {isTeam && (
            <form
              className="inline-form report-create"
              onSubmit={add}
            >
              <input
                placeholder="Nombre del reporte"
                value={name}
                onChange={event =>
                  setName(event.target.value)
                }
                required
              />

              <button className="btn primary">
                Crear reporte
              </button>
            </form>
          )}

          {items.length ? (
            <div className="table-list">
              {items.map(item => (
                <div
                  className="table-row"
                  key={item.id}
                >
                  <div className="file-icon">▤</div>

                  <div className="grow">
                    <b>{item.name}</b>

                    <small>
                      {item.published_at
                        ? `Publicado ${dateText(
                            item.published_at,
                          )}`
                        : 'Borrador'}
                    </small>
                  </div>

                  <Status value={item.status} />

                  {isTeam &&
                    item.status !== 'published' && (
                      <button
                        className="btn soft"
                        onClick={() =>
                          publish(item.id)
                        }
                      >
                        Publicar
                      </button>
                    )}
                </div>
              ))}
            </div>
          ) : (
            <Empty
              title="Sin reportes"
              text="Todavía no hay reportes publicados."
            />
          )}
        </div>
      )}
    </>
  )
}

function AdminView({
  organizationId,
  isTeam,
  setToast,
}) {
  const [invoices, setInvoices] = useState([])
  const [documents, setDocuments] = useState([])

  const [form, setForm] = useState({
    number: '',
    amount: '',
    currency: 'COP',
    status: 'pending',
    due_date: '',
  })

  const load = useCallback(() => {
    if (!organizationId) {
      setInvoices([])
      setDocuments([])
      return
    }

    Promise.all([
      supabase
        .from('clientops_invoices')
        .select('*')
        .eq('organization_id', organizationId)
        .order('due_date', {
          ascending: false,
        }),

      supabase
        .from('clientops_documents')
        .select('*')
        .eq('organization_id', organizationId)
        .order('created_at', {
          ascending: false,
        }),
    ]).then(([invoiceResult, documentResult]) => {
      if (invoiceResult.error) {
        setToast(invoiceResult.error.message)
      } else {
        setInvoices(invoiceResult.data || [])
      }

      if (documentResult.error) {
        setToast(documentResult.error.message)
      } else {
        setDocuments(documentResult.data || [])
      }
    })
  }, [organizationId, setToast])

  useEffect(() => {
    load()
  }, [load])

  async function addInvoice(event) {
    event.preventDefault()

    const { error } = await supabase
      .from('clientops_invoices')
      .insert({
        ...form,
        organization_id: organizationId,
        amount: Number(form.amount),
      })

    if (error) {
      setToast(error.message)
      return
    }

    setForm({
      number: '',
      amount: '',
      currency: 'COP',
      status: 'pending',
      due_date: '',
    })

    load()
  }

  async function upload(event) {
    const file = event.target.files?.[0]

    if (!file) return

    const path = `${organizationId}/${Date.now()}-${file.name.replace(
      /[^a-zA-Z0-9._-]/g,
      '_',
    )}`

    const uploadResult = await supabase.storage
      .from('clientops-documents')
      .upload(path, file)

    if (uploadResult.error) {
      setToast(uploadResult.error.message)
      return
    }

    const { error } = await supabase
      .from('clientops_documents')
      .insert({
        organization_id: organizationId,
        title: file.name,
        kind: 'document',
        storage_path: path,
        visible_to_client: true,
      })

    if (error) {
      setToast(error.message)
      return
    }

    setToast('Documento cargado.')
    load()
  }

  async function download(document) {
    const { data, error } = await supabase.storage
      .from('clientops-documents')
      .createSignedUrl(document.storage_path, 60)

    if (error) {
      setToast(error.message)
    } else {
      window.open(data.signedUrl, '_blank')
    }
  }

  return (
    <>
      <PageTitle
        eyebrow="ADMINISTRACIÓN"
        title="Facturación y documentos"
        description="Información administrativa de la cuenta, visible solo para los usuarios autorizados."
      />

      {!organizationId ? (
        <Empty
          title="Selecciona una cuenta"
          text="La información administrativa pertenece a un cliente."
        />
      ) : (
        <div className="two-col">
          <div className="card">
            <div className="card-head">
              <h3>Facturas</h3>

              {isTeam && (
                <Status value="gestión interna" />
              )}
            </div>

            {isTeam && (
              <form
                className="form mini"
                onSubmit={addInvoice}
              >
                <div className="form-row">
                  <label>
                    Número

                    <input
                      value={form.number}
                      onChange={event =>
                        setForm({
                          ...form,
                          number: event.target.value,
                        })
                      }
                      required
                    />
                  </label>

                  <label>
                    Valor

                    <input
                      type="number"
                      value={form.amount}
                      onChange={event =>
                        setForm({
                          ...form,
                          amount: event.target.value,
                        })
                      }
                      required
                    />
                  </label>
                </div>

                <div className="form-row">
                  <label>
                    Estado

                    <select
                      value={form.status}
                      onChange={event =>
                        setForm({
                          ...form,
                          status: event.target.value,
                        })
                      }
                    >
                      <option value="pending">
                        Pendiente
                      </option>

                      <option value="paid">
                        Pagada
                      </option>

                      <option value="overdue">
                        Vencida
                      </option>
                    </select>
                  </label>

                  <label>
                    Vence

                    <input
                      type="date"
                      value={form.due_date}
                      onChange={event =>
                        setForm({
                          ...form,
                          due_date: event.target.value,
                        })
                      }
                    />
                  </label>
                </div>

                <button className="btn primary">
                  Registrar factura
                </button>
              </form>
            )}

            {invoices.length ? (
              <div className="table-list">
                {invoices.map(invoice => (
                  <div
                    className="table-row"
                    key={invoice.id}
                  >
                    <div className="file-icon">$</div>

                    <div className="grow">
                      <b>{invoice.number}</b>

                      <small>
                        {money(
                          invoice.amount,
                          invoice.currency,
                        )}{' '}
                        · vence{' '}
                        {dateText(invoice.due_date)}
                      </small>
                    </div>

                    <Status value={invoice.status} />
                  </div>
                ))}
              </div>
            ) : (
              <p className="muted">
                No hay facturas registradas.
              </p>
            )}
          </div>

          <div className="card">
            <div className="card-head">
              <h3>Contratos y documentos</h3>

              {isTeam && (
                <label className="btn soft file-button">
                  Cargar archivo

                  <input
                    type="file"
                    onChange={upload}
                  />
                </label>
              )}
            </div>

            {documents.length ? (
              <div className="table-list">
                {documents.map(document => (
                  <button
                    className="table-row clickable"
                    key={document.id}
                    onClick={() => download(document)}
                  >
                    <div className="file-icon">↧</div>

                    <div className="grow">
                      <b>{document.title}</b>

                      <small>
                        {document.kind} ·{' '}
                        {dateText(document.created_at)}
                      </small>
                    </div>
                  </button>
                ))}
              </div>
            ) : (
              <p className="muted">
                No hay documentos cargados.
              </p>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default App
